exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-content[data-v-246adb6d] {\n  opacity: 0.5;\n  text-align: center;\n  color: var(--secondary);\n  width: 100%;\n  top: 50%;\n  left: 0;\n  position: absolute;\n  transform: translateY(-50%);\n}", ""]);

// exports
